<template>
<div class="chapter">
<div class="inner_page">
<div id="Acknowledgements">
<p class="fm-title"><a id="page_vi"><b>Acknowledgements</b></a></p><a id="page_vi">
<p class="noindent1">I wish to acknowledge and thank the Trustees of the Liddell Hart Centre for Military Archives for permission to use quotations form their archives.</p>
</a></div><a id="page_vi">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Acknowledgements.vue?5588fd8c